import { ReactNode } from 'react';
import { IControlProps, IPartialFormGroup } from '../types';
import type { IOption } from '../../types/IOption';
import FormControl from '../FormControl';

import { useHookFormController } from '../../hooks/useHookFormController';
import AutoCompletePicker, { IAutoCompletePickerProps } from '../../atoms/AutoCompletePicker';

export type IAutoCompleteControlProps = IAutoCompletePickerProps &
    IControlProps & {
        formGroupProps?: IPartialFormGroup;
        label?: ReactNode;
        tooltip?: ReactNode;
        required?: boolean;
        onValueChange?: (value: string) => void;
        findOptions: (value: string) => Promise<IOption[]>;
    };

const AutoCompleteControl = ({
    name,
    rules,
    control,
    shouldUnregister,
    formGroupProps,
    label,
    tooltip,
    required,
    onValueChange,
    findOptions,
    ...props
}: IAutoCompleteControlProps) => {
    const Controller = useHookFormController();
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            render={({ field: { onChange, value, ...fieldProps } }) => (
                <FormControl
                    readonlyAppearance={props.disabled ? 'field' : undefined}
                    name={name}
                    label={label}
                    tooltip={tooltip}
                    required={required}
                    control={control}
                    {...formGroupProps}
                >
                    <AutoCompletePicker
                        {...fieldProps}
                        {...props}
                        value={value}
                        debounceTime={500}
                        clearOnSelect={false}
                        findOptions={findOptions}
                        onSearchChange={(val: string) => {
                            if (value === undefined || value === null || value.toString() != val.toString()) {
                                onChange(val);
                                if (onValueChange) {
                                    onValueChange(val);
                                }
                            }
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default AutoCompleteControl;
